module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_01_6DD79_1SE_GAZ.02b860de.png";